module.exports = "/static/assets/a179def1e7266cfec58e468b70457ca0.png";